export { default } from './MobileOnlyCarousel';
